import React from "react";
import styled from "styled-components";
import Block from "components/layout/Block";

const ContainerSection = styled(Block)`
	width: 100%;
`;

const TopSection = styled(Block)`
	margin-bottom: 1rem;
`;

const BottomSection = styled(Block)`
	margin-top: 1rem;
`;

export default ({ top, main, bottom, pagination, afterPagination }) => {
	return (
		<ContainerSection>
			{top && (
				<TopSection flex justifyStart>
					{top}
				</TopSection>
			)}
			{main}
			{bottom && (
				<BottomSection flex justifyEnd>
					{bottom}
				</BottomSection>
			)}
			{pagination && <BottomSection flex>{pagination}</BottomSection>}
			{afterPagination && (
				<BottomSection flex>{afterPagination}</BottomSection>
			)}
		</ContainerSection>
	);
};
